// The Forge in the zone framework (docs/build/zones.md): main.ts imports this module for its side effects. It
// registers the zone's own section kinds (zones/developers/zone.json "sections"). Section kinds are global, so each
// handler draws only for this zone and hands any other zone to whatever was registered before it.

import { registerSection, sectionRenderer, type SectionContext, type SectionRender } from "../registry.ts";
import { benchmarkSection, hookSection, pathSection, templateSection, waysSection, whySection } from "./forge.ts";
import { ensureForgeStyle } from "./style.ts";

export const ZONE_ID = "developers";

function own(kind: string, render: (ctx: SectionContext) => HTMLElement | null): void {
  const before: SectionRender | undefined = sectionRenderer(kind);
  registerSection(kind, (ctx) => {
    if (ctx.zone.id !== ZONE_ID) return before ? before(ctx) : null;
    ensureForgeStyle();
    return render(ctx);
  });
}

own("hook", hookSection);
own("benchmark", benchmarkSection);
own("why", whySection);
own("path", pathSection);
own("template", templateSection);
own("ways", waysSection);
